import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";

export const GlobalConfigurationClientManager = (function ($) {

	var restUrl = "globalConfiguration/fields";

	var fieldsToGet = ['publicHostInformation', 'contentServerSettings', 'globalSettings', 'carlXWebEcommerceSettings', 'ldapEnabled', 'casEnabled', 'casSettings', 'adfsEnabled', 'adfsSettings', 'googleOauthEnabled', 'obrEnabled', 'borrowerNotificationTypes', 'smsGateways'];

	var globalConfiguration = {};

	const getGlobalConfigurationEvent = LS2PAC_CONSTANTS.Events.onGetGlobalConfiguration;

	TLCEventManager.addListener(getGlobalConfigurationEvent, function () {
		onGetGlobalConfiguration();
	});

	var onGetGlobalConfiguration = function () {
		TLCRest.jsonCall(restUrl, {
			postData:fieldsToGet,
			cache: false,
			callback:function (data) {
				TLCLogger.log("data", data);
				globalConfiguration = {};
				for (var i = 0, len = fieldsToGet.length; i < len; i++) {
					var field = data[i];
					if (field != null) {
						globalConfiguration[fieldsToGet[i]] = field;
					}
				}
				globalConfiguration.sharingEnabled = globalConfiguration.globalSettings.sharingEnabled;
				globalConfiguration.useForgotPasswordLink = globalConfiguration.globalSettings.useForgotPasswordLink;
				globalConfiguration.hostInformation = globalConfiguration.publicHostInformation;
				globalConfiguration.altCreds = $.extend({id:{name:'barcode', label:ApplicationData.language.barcode}}, JSON.parse(globalConfiguration.hostInformation.passwords.replace(/'/g, '"')));
				$.each(globalConfiguration.altCreds.passwords, function (index, item) {
					item.label = ApplicationData.language[item.name];
				});

				globalConfiguration.Text = {};

				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetGlobalConfigurationResponse, {success:true, data:globalConfiguration});

				TLCLogger.log("global config callback", globalConfiguration);
			}
		});
	};

	return {
		getGlobalConfiguration:function () {
			return globalConfiguration;
		},
		getGlobalConfigurationEvent: getGlobalConfigurationEvent
	};

})(jQuery);
